import { GradeMappingsSchema } from "@redotech/redo-return-settings-common/grade-mapping";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

/** Saved grade mappings; an empty list means the merchant uses the default grade actions. */
export const getGradeMappings = unaryRpc({
  name: "getGradeMappings" as const,
  input: z.object({}),
  output: z.object({ gradeMappings: GradeMappingsSchema }),
});

export const updateGradeMappings = unaryRpc({
  name: "updateGradeMappings" as const,
  input: z.object({ gradeMappings: GradeMappingsSchema }),
  output: z.object({ gradeMappings: GradeMappingsSchema }),
});
